export default function DeleteIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <g clipPath='url(#clip0_513_1745)'>
        <path
          d='M16.333 9V19H8.33301V9H16.333ZM14.833 3H9.83301L8.83301 4H5.33301V6H19.333V4H15.833L14.833 3ZM18.333 7H6.33301V19C6.33301 20.1 7.23301 21 8.33301 21H16.333C17.433 21 18.333 20.1 18.333 19V7Z'
          fill='#ED0710'
        />
      </g>
      <defs>
        <clipPath id='clip0_513_1745'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0.333008)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
